/**
 * Uma linha por fonte dizendo o que ela traz (spec 2026-09-27, 4.4, passo
 * Alertas). Vale para os tenants que o robô acompanha, e só o que a pessoa já
 * pode ver no Console. Fonte sem linha aqui aparece só com o nome.
 *
 * Só leva linha a fonte com produtor no backend (um parser de `ingest.py` ou
 * um `emit` com esse `source`). `provisioning`, `database`, `rbac`, `finops`,
 * `gitlab`, `aws_backup` e `security_auth` estão em `PREFERENCE_SOURCES` mas
 * ninguém grava com esse nome — `rbac`/`finops` saem como `audit`, o GitLab
 * como `cicd_gitlab` — e descrever o que elas trariam seria prometer evento
 * que não vem (review final de 27/09/2026).
 */
export const O_QUE_A_FONTE_TRAZ: Record<string, string> = {
  audit: 'Ações registradas na trilha de auditoria.',
  notification: 'Avisos gerais do Console para você.',
  inbox: 'Pedidos pendentes e mudanças de chamado que esperam uma ação sua.',
  chamado: 'Chamados abertos e atualizados.',
  cloudwatch_alarm: 'Alarmes do CloudWatch que mudam de estado.',
  guardduty: 'Achados de ameaça do GuardDuty.',
  securityhub: 'Achados de segurança do Security Hub.',
  zabbix: 'Problemas de host e serviço monitorados pelo Zabbix.',
  ztna: 'Acesso ZTNA: mudanças e falhas.',
  cloudtrail: 'Chamadas de API sensíveis registradas no CloudTrail.',
  aws_health: 'Avisos do AWS Health sobre a conta e os serviços.',
  cost_anomaly: 'Anomalias de custo detectadas pela AWS.',
  alb_target_health: 'Alvos de balanceador que ficaram fora do ar.',
  ecs_service: 'Serviços ECS: deploy e tarefas que caem.',
  gmud_lifecycle: 'GMUDs: aprovação, execução e encerramento.',
  provisioning_saga: 'Etapas do provisionamento de tenant.',
  cicd_gitlab: 'Pipelines de CI/CD do GitLab.',
  wazuh: 'Alertas de segurança do Wazuh (SIEM).',
  host_order: 'Pedidos de limpeza e reinício no host e os avisos das regras de ordem.',
}
